var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6 .583a.75.75 0 0 1 .75.75V5.25h3.916a.75.75 0 1 1 0 1.5H6.75v3.917a.75.75 0 1 1-1.5 0V6.75H1.333a.75.75 0 0 1 0-1.5H5.25V1.333A.75.75 0 0 1 6 .583",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;